import { render, staticRenderFns } from "./CardPropertyGeoPointEditor.vue?vue&type=template&id=4c38e0bf&scoped=true&"
import script from "./CardPropertyGeoPointEditor.vue?vue&type=script&lang=js&"
export * from "./CardPropertyGeoPointEditor.vue?vue&type=script&lang=js&"
import style0 from "./CardPropertyGeoPointEditor.vue?vue&type=style&index=0&id=4c38e0bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c38e0bf",
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign({QInput}, component.options.components || {})
